import { useTranslation } from "react-i18next";
import { Grid, Column, Row } from "@components/Grid";
import { Button, ButtonSize } from "@components/Button";
import { Text, TextType, TextSize } from "@components/Text";
import Box from "@components/Box";
import SuccessIcon from "@assets/icons/success.svg";
import WarningIcon from "@assets/icons/warning-yellow.svg";
import { Modal } from "@components/Modal";

interface MessageModalProps {
  title: string,
  description: string,
  okBtnTitle?: string,
  onClose: () => void;
  mode?: string;
}

const getIcon = (mode: string) => {
  const icons: Record<string, string> = {
    warning: WarningIcon,
    success: SuccessIcon,
  }
  return icons[mode] ?? "";
}

export const MessageModalContent = ({
  title,
  description,
  okBtnTitle,
  onClose,
  mode,
}: MessageModalProps) => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: "320px", margin: "20px auto" }}>
      <Grid>
        <Column phone={12}>
          <Row align="center">
            <Box textAlign="center">
              <img alt="Icon" src={getIcon(mode ?? "success")} width="62px" />
            </Box>
          </Row>
          <Row align="center">
            <Box pt={6} textAlign="center">
              <Text type={TextType.H1}>
                {title}
              </Text>
            </Box>
          </Row>
          <Row align="center">
            <Box pt={2} textAlign="center">
              <Text
                size={TextSize.M}
                dangerouslySetInnerHTML={{
                  __html: {description},
                }}
              />
            </Box>
          </Row>
        </Column>

        <Row>
          <Column phone={12}>
            <Box pt={5} textAlign="center">
              <Button
                title={okBtnTitle ?? t("successModal.defaultOkBtn")}
                size={ButtonSize.S}
                onClick={onClose}
              />
            </Box>
          </Column>
        </Row>

      </Grid>
    </div>
  );
};

const MessageModal: React.FC<MessageModalProps> = (props: MessageModalProps): React.ReactElement => {
  return (
    <Modal
      isOpen={true}
      onClickOverlay={props.onClose}
      onClose={props.onClose}
    >
      <MessageModalContent {...props} />
    </Modal>
  );
}

export default MessageModal;
